<template>
  <form class="form" @submit.prevent="handleSubmit">
    <slot />
  </form>
</template>

<script>
/**
 * フォーム
 */
export default {
  name: 'Form',
  methods: {
    handleSubmit(e) {
      /**
       * サブミットイベント
       * @event submit
       * @type {Event}
       */
      this.$emit('submit', e)
    },
  },
}
</script>

<style lang="postcss" scoped>
.form {
  background: var(--white);
  display: flex;
  flex-direction: column;
  padding: 32px;
}
</style>
